function getSection(sectionId) {

    return document.querySelector(`[data-section-id="${sectionId}"]`);
}

function getSectionId(button) {

    return button.getAttribute('data-nav-button-for-section');
}

function show(button) {
    button.classList.remove('aboutNav__button--hidden');
}

function maybeShow(button) {
    const section = getSection(getSectionId(button));
    
    if (section) {
        show(button);
    }
}

function init() {
    const buttons = [...document.querySelectorAll('[data-nav-button-for-section]')];

    buttons.forEach(maybeShow);
}

$(document).ready(init);
